import { type JSX } from 'react';

import { MultiMeterBarChartSegment } from './MultiMeterBarChartSegment.js';
import { useMeterBarLayoutSize } from '../../shared/context/MeterBarLayoutSizeContext.js';
import { getSegmentWidth } from '../../shared/utils/get-segment-width.js';
import { useMultiMeterBarVisibleSegmentsState } from '../hooks/store/selectors.js';

interface MultiMeterBarChartSegmentsProps {
  max: number;
  min: number;
}

export const MultiMeterBarChartSegments = (
  props: MultiMeterBarChartSegmentsProps,
) => {
  const { max, min } = props;
  const { segmentWidth: width } = useMeterBarLayoutSize();
  const segments = useMultiMeterBarVisibleSegmentsState();

  if (!segments || !segments.length) {
    return null;
  }

  const { segmentComponents } = segments.reduce(
    (acc, current, index) => {
      const segmentWidth = getSegmentWidth(current.value, min, max, width);

      const segmentComponent = (
        <MultiMeterBarChartSegment
          previousSegmentsWidth={acc.usedWidth}
          segmentId={current.id}
          segmentIndex={index}
          segmentColor={current.color}
          segmentWidth={segmentWidth}
          key={current.id}
        />
      );

      acc = {
        segmentComponents: [...acc.segmentComponents, segmentComponent],
        usedWidth: acc.usedWidth + segmentWidth,
      };

      return acc;
    },
    {
      segmentComponents: [] as JSX.Element[],
      usedWidth: 0,
    },
  );

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{segmentComponents}</>;
};

MultiMeterBarChartSegments['displayName'] = 'MultiMeterBarChartSegments';
